<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon>
          <v-avatar size="24">
            <i class="fas fa-headset"></i>
          </v-avatar>
        </v-app-bar-nav-icon>
        <v-toolbar-title>Add a new platform</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="pa-0">
        <v-card flat tile class="ma-0">
          <v-card-text class="pa-0">
            <v-stepper vertical v-model="step">
              <v-stepper-step step="1" :complete="step > 1" editable class="ma-0">
                Platform Details
                <small>The business details of the platform</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs6>
                            <v-text-field
                              label="Platform Name"
                              v-model="details.business.commercialName"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 class="pl-4 pt-4">
                            <v-switch label="Enabled" v-model="details.enabled"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
                <v-btn color="accent" @click.native="step = 2" :disabled="stepOneInvalid">Continue</v-btn>
              </v-stepper-content>
              <v-stepper-step
                step="2"
                :complete="step > 2"
                editable
                class="ma-0"
                :rules="[() => !RegistrationEmailExists]"
              >
                User
                <small v-if="RegistrationEmailExists">Email address is already registered</small>
                <small v-else>The primary user for the account</small>
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-card flat tile class="ma-0 mb-5">
                  <v-card-text class="pa-0">
                    <v-form lazy-validation>
                      <v-container fluid grid-list-md class="pa-0">
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs6>
                                <v-text-field label="First name" v-model="details.firstName" required></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field label="Last name" v-model="details.lastName" required></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field
                                  label="Email"
                                  v-model="verifiedEmail"
                                  :rules="emailRules"
                                  required
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field label="Phone" v-model="details.phone" required></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout wrap class="pl-2">
                              <h4>User Roles</h4>
                            </v-layout>
                            <v-layout wrap class="pl-2">
                              <v-flex>
                                <v-switch flex label="Platform" v-model="details.roles.Platform"></v-switch>
                              </v-flex>
                              <v-flex>
                                <v-switch flex label="Owner" v-model="details.roles.Owner"></v-switch>
                              </v-flex>
                              <v-flex>
                                <v-switch flex label="Call Centre" v-model="details.roles.Call_Centre"></v-switch>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-btn color="accent" @click.native="register" :disabled="stepTwoInvalid">Add</v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import { emailRegex, emailRules } from '@/utils/validators';

export default {
  name: 'new-platform-dialog',
  props: ['show'],
  data: () => ({
    step: 1,
    details: {
      business: {
        commercialName: null,
        type: 'platform'
      },
      enabled: false,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      roles: {
        Platform: false,
        Owner: false,
        Call_Centre: false
      }
    },
    emailRules
  }),
  computed: {
    ...mapGetters(['RegistrationEmailExists']),
    stepOneInvalid: function() {
      return _.isNull(this.details.business.commercialName);
    },
    stepTwoInvalid: function() {
      return (
        this.RegistrationEmailExists ||
        _.isNull(this.details.firstName) ||
        _.isNull(this.details.lastName) ||
        _.isNull(this.verifiedEmail) ||
        !emailRegex.test(this.verifiedEmail)
      );
    },
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    verifiedEmail: {
      get() {
        return this.details.email;
      },
      set: _.debounce(function(email) {
        this.details.email = email;
        this.verifyRegistrationEmail(email);
      }, 500)
    }
  },
  methods: {
    ...mapActions(['addPlatform', 'verifyRegistrationEmail']),
    clearRegistration() {
      this.details = {
        business: {
          commercialName: null,
          type: 'platform'
        },
        enabled: false,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        roles: []
      };
    },
    register() {
      this.addPlatform(this.details).then(() => {
        this.$emit('success');
        this.closeDialog();
      });
    },
    closeDialog() {
      this.clearRegistration();
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
